import type { ParametrosDeliveryModel } from "../models/parametrosDeliveryModel"

export enum ParametrosDeliveryActionsTypes {
    CARREGAR = "CARREGAR",
    ATUALIZAR_CAMPO = "ATUALIZAR_CAMPO",
    RESETAR = "RESETAR",
}

export type ParametrosDeliveryActionModel =
    | { type: ParametrosDeliveryActionsTypes.CARREGAR; payload: ParametrosDeliveryModel }
    | {
          type: ParametrosDeliveryActionsTypes.ATUALIZAR_CAMPO
          payload: { campo: keyof ParametrosDeliveryModel; valor: string | number | boolean | null }
      }
    | { type: ParametrosDeliveryActionsTypes.RESETAR }
